'use strict';
module.exports = require('./Divider.vue');